<div class="d-flex flex-column gap-2">

  <!-- ── Dates ─────────────────────────────────────────────────── -->
  @if (damageEventDate || preDamageDate) {
    <div class="pb-1">
      @if (damageEventDate) {
        <div class="small fw-medium">Damage Info based on {{ damageEventDate | date }} imagery</div>
      }
      @if (preDamageDate) {
        <div class="text-muted small">Pre-damage Property Info based on {{ preDamageDate | date }} imagery</div>
      }
    </div>
  }

  <!-- ── Structure Cards ────────────────────────────────────────── -->
  @for (structure of structures; track $index; let i = $index) {
    <lib-damage-structure-card
      [damageStructure]="structure"
      [structure]="preStructures[i]"
      [index]="i + 1"
      [expanded]="i === 0"
      [measurementSystem]="measurementSystem"
      [parcelWkt]="parcelWkt"
      (zoomRequested)="zoomRequested.emit($event)">
    </lib-damage-structure-card>
  }

  <!-- ── Pre-Damage Property Features ─────────────────────────── -->
  @if (damageData?.pre_catastrophe?.property_features) {
    <mat-expansion-panel class="property-panel" [expanded]="true">
      <mat-expansion-panel-header class="pe-0">
        <mat-panel-title>Property Features</mat-panel-title>
        <mat-panel-description (click)="$event.stopPropagation()">
          <button mat-icon-button [matMenuTriggerFor]="featuresMenu" aria-label="Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu panelClass="actions-menu" #featuresMenu>
            <button mat-menu-item (click)="copyToClipboard(parcelWkt)">
              <mat-icon>content_copy</mat-icon>
              <span>Copy Parcel Boundary</span>
            </button>
            <button mat-menu-item (click)="zoomRequested.emit({ wkt: parcelWkt, paddingPx: 100 })">
              <mat-icon svgIcon="send"></mat-icon>
              <span>Zoom to Parcel</span>
            </button>
          </mat-menu>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="d-flex flex-column">
        @let propertyFeatures = getPropertyFeatures();
        <div class="d-flex justify-content-between align-items-center pt-1">
          <span class="small text-muted fw-semibold">Property Features</span>
          <button mat-button class="mat-button-slim hide-button" (click)="showAllPropertyFeatures = !showAllPropertyFeatures" type="button">
            {{ showAllPropertyFeatures ? "Hide undetected features" : "Show undetected features" }}
          </button>
        </div>
        @if (!showAllPropertyFeatures && propertyFeatures.length === 0) {
          <div class="no-features-message" style="font-size: 0.6rem;">No features were detected for this property</div>
        }
        <mat-chip-set>
          @for (chip of propertyFeatures; track chip.label + (chip.type ?? '')) {
            <mat-chip class="my-0" [class.chip-empty]="!chip.detected">
              {{ chip.label }}@if (chip.detail) { ({{ chip.detail }})}
            </mat-chip>
          }
        </mat-chip-set>
      </div>

    </mat-expansion-panel>
  }

  <!-- ── Controls ───────────────────────────────────────────────── -->
  <div class="d-flex align-items-center justify-content-between mt-auto pt-2 border-top">
    <div class="d-flex align-items-center">
      <mat-checkbox class="mat-checkbox-slim"
                    [checked]="visibilityValues?.propertyFootprint"
                    (change)="onVisibilityChange('propertyFootprint', $event.checked)"
                    [disabled]="discreteEnabled">
        <span class="small">Footprints</span>
      </mat-checkbox>
      <mat-checkbox class="mat-checkbox-slim"
                    [checked]="visibilityValues?.labelsFootprint"
                    (change)="onVisibilityChange('labelsFootprint', $event.checked)"
                    [disabled]="discreteEnabled">
        <span class="small">Building labels</span>
      </mat-checkbox>
    </div>
    <mat-select [value]="measurementSystem"
                (valueChange)="onMeasurementSystemChange($event)"
                class="mat-select-slim"
                panelClass="mat-select-slim-panel">
      <mat-option [value]="measurementSystems.IMPERIAL">Imperial</mat-option>
      <mat-option [value]="measurementSystems.METRIC">Metric</mat-option>
    </mat-select>
  </div>

</div>